import { IOpenMarketProduct } from '../../../interfaces/Product.interfaces';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

interface IGetOpenMarketProductsParams {
  searchParam?: {
    status: string;
    count?: number;
  };
}

export const getOpenMarketProducts = ({ searchParam }: IGetOpenMarketProductsParams): Promise<IOpenMarketProduct[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/user-sell-tractors?${URLSearchParams}`);
};
